import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const HomeWorkoutIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/home_workout.svg" });
};
const styles = StyleSheet.create({
    container: {
        width: 22,
        height: 22,
    },
});
